import { Component } from 'react';
import { connect } from 'react-redux';
import { locationShape, routerShape } from 'react-router';
import {
    get,
    filter,
    includes,
    lowerCase
} from 'lodash';
import { createSelector } from 'reselect';
import GroupList from 'part11/components/GroupList/GroupList';
import styles from 'part11/components/GroupList/GroupList.scss';
import SearchBar from 'common/components/SearchBar/SearchBar';
import {
    setActionButton,
    clearActionButton,
} from 'common/actions/actionButtonActions';
import {
    initializeScene,
    clearScene
} from 'common/actions/scene';
import {
    clearGroupsScene,
    initializeGroupsScene
} from 'part11/actions/groups';

export class Groups extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {
            institutionId,
            initializeScene,
            initializeGroupsScene
        } = this.props;

        initializeScene();
        initializeGroupsScene(institutionId);
    }

    componentWillUnmount() {
        this.props.clearActionButton();
        this.props.clearGroupsScene();
        this.props.clearScene();
    }

    render() {
        const { router, location } = this.context;
        return (
            <div className={styles.groupContainer}>
                <SearchBar
                    router={router} location={location}
                    placeholder="Search groups by associated user name or group name"/>
                <GroupList title="Groups"
                    groups={this.props.groups}
                    institutionId={this.props.institutionId}
                />
            </div>
        );
    }
}

const getQueryFilter = state => get(state, 'routing.locationBeforeTransitions.query.q', '');
const getGroups = state => get(state, 'scene.groups', []);

const getSearchedGroups = createSelector(
    [ getQueryFilter, getGroups ],
    ( query, groups ) =>
        query === ''
            ? groups
            : filter(groups, g => {
                query = lowerCase(query);
                if(includes(lowerCase(g.displayName), query)){
                    return true;
                }
                if(g.users && g.users.length > 0){
                    const filteredUsers = filter(g.users, u => includes(lowerCase(u.displayName), query));
                    return filteredUsers.length > 0;
                }
            })
);

Groups.contextTypes = {
    router: routerShape.isRequired,
    location: locationShape.isRequired,
};

export default connect(
    (state, ownProps) => {
        return {
            institutionId: ownProps.institutionId || get(state, 'me.institution.id'),
            groups: getSearchedGroups(state)
        };

    }, {
        clearGroupsScene,
        setActionButton,
        clearActionButton,
        initializeScene,
        clearScene,
        initializeGroupsScene
    }
)(Groups);
